export default function Footer() {
  return (
    <footer id="footer" className="bg-background-950 text-white">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="lg:col-span-1">
            <span className="font-heading text-2xl font-bold text-primary-400">8090影视</span>
            <p className="text-sm text-white/50 mt-3 leading-relaxed max-w-xs">
              8090影视打造电影大全平台，聚合最新电影、经典电影、高清电影资源，涵盖华语电影、欧美电影等海量片库，高清画质流畅播放尽在掌握。
            </p>
            <div className="flex items-center gap-3 mt-4">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-white/10 text-white/60 hover:text-primary-400 hover:bg-white/20 transition-colors cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-white/10 text-white/60 hover:text-primary-400 hover:bg-white/20 transition-colors cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-white/10 text-white/60 hover:text-primary-400 hover:bg-white/20 transition-colors cursor-pointer" aria-label="B站">
                <i className="ri-bilibili-line"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-white mb-4">快速导航</h4>
            <div className="flex flex-col gap-2.5">
              {[
                { label: '热播榜单', href: '#ranking' },
                { label: '最新动态', href: '#updates' },
                { label: '片库索引', href: '#index' },
                { label: '焦点专题', href: '#carousel' },
                { label: '常见问题', href: '#faq' },
              ].map((item) => (
                <a key={item.href} href={item.href} className="text-sm text-white/50 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">{item.label}</a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-white mb-4">电影分类</h4>
            <div className="flex flex-col gap-2.5">
              {['华语电影', '欧美电影', '日韩电影', '动画电影', '纪录片'].map((cat) => (
                <a key={cat} href="#index" className="text-sm text-white/50 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">{cat}</a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-white mb-4">合作伙伴</h4>
            <p className="text-sm text-white/40 leading-relaxed">感谢所有合作伙伴的支持与信任，共同打造优质的影视内容生态。</p>
          </div>
        </div>

        <div className="border-t border-white/10 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-white/30">© 2026 8090影视 版权所有</p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-white/30 hover:text-white/50 transition-colors cursor-pointer">隐私政策</a>
            <a href="#" className="text-xs text-white/30 hover:text-white/50 transition-colors cursor-pointer">服务条款</a>
            <a href="#contact" className="text-xs text-white/30 hover:text-white/50 transition-colors cursor-pointer">联系我们</a>
          </div>
        </div>
      </div>
    </footer>
  );
}